/**
 * @vuepress
 * ---
 * title: followupTransformer
 */

import Transformer from '@/transformers/transformer'
// import { attachMissingCurrentTime } from '@/utils/moment'

/**
 * @class followupTransformer
 * @author José Luis Ruiz
 */

// const userFullName = ({ treatment, name, first_name: firstName, last_name: lastName, mothers_last_name: secondLastName, username }) =>
//   `${treatment || ''} ${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`

class followupHistoryTransformer extends Transformer {
  static fetch({
    add_date: addDate,
    changed_by: changedBy,
    modified_fields: modifiedFields
  }) {
    return {
      addDate,
      changedBy,
      modifiedFields
    }
  }
}
export default followupHistoryTransformer
